import TriggeredEvent = JQuery.TriggeredEvent;

export type DimeData = { [key :string] :any };

export type DimeDataCheck<T> = DimeData | T;

type DimePrepare = {
   name :string,
   onEvent? :(event :TriggeredEvent) => void,
   getData? :<T>(event :TriggeredEvent) => DimeDataCheck<T>,
};

type Listener = (data :DimeData) => Promise<void> | void | undefined;

declare global
{
   interface Window
   {
      Dime :{
         addPrepares(prepares :Array<DimePrepare>) :void,
      },
   }
}

class Dime
{

   public addPrepares(prepares :Array<DimePrepare>) :void {
      prepares.forEach(prepare => this.prepares.set(prepare.name, prepare));
   }

   public addListeners(listeners :Record<string, Listener>) :void {
      for(const [name, listener] of Object.entries(listeners)){
         this.listeners[name] = this.listeners[name] || [];
         this.listeners[name].push(listener);
      }
   }

   public register() :void {
      const atribut = 'data-dime-register';

      $(document).on(this.getListenedEvents().join(' '), `[${atribut}]`, (e :TriggeredEvent) => {
         Array.from(String($(e.currentTarget).attr(atribut)).matchAll(new RegExp(`${e.type}:(\\S+)`, 'g')))
            .map(match => match[1])
            .forEach(eventName => {
               const prepare = this.prepares.get(`${e.type}:${eventName}`);

               if(prepare && prepare.onEvent)
                  prepare.onEvent(e);

               this.trigger(
                  eventName,
                  prepare && prepare.getData
                     ? prepare.getData(e)
                     : undefined,
               );
            });
      });
   }

   public trigger(name :string, data ? :DimeData) {
      const names = [
         name + ':before',
         name,
         name + ':after',
      ];

      const run = async() :Promise<void> => {
         const name = names.shift();

         if(name){
            const promises = this.listeners[name]?.map(listener => listener(data ? data : {})) || [];

            return Promise.all(promises)
               .then(run);
         }
      };

      run();
   }

   protected getListenedEvents() :Array<Partial<keyof GlobalEventHandlersEventMap>> {
      return [
         'click',
         'mouseover',
         'mouseout',
         'mousedown',
         'mouseup',
         'mousemove',
         'change',
         'focus',
         'keydown',
         'keypress',
         'keyup',
         'submit',
      ];
   }

   protected listeners :Record<string, Array<Listener>> = {};
   protected prepares :Map<string, DimePrepare> = new Map();
}

let dimeInstance :Dime;

export default (dimeInstance = new Dime());

window.Dime = {
   addPrepares(prepares :Array<DimePrepare>) {
      dimeInstance.addPrepares(prepares);
   },
};
